import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, className = "", align = "left" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} ${className}`}>
    {eyebrow && (
      <Reveal variant="fade">
        <p className="text-xs md:text-sm tracking-[0.35em] uppercase font-bold text-gold mb-5 flex items-center gap-3">
          {align !== "center" && <span className="w-8 h-px bg-gold" />}
          {eyebrow}
        </p>
      </Reveal>
    )}
    <Reveal>
      <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.9] tracking-tight uppercase text-offwhite">
        {title}
      </h2>
    </Reveal>
  </div>
);
